var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6026_29005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.45085 4L2.90228 6.24427L6.45085 8.4886L9.99998 6.24427L6.45085 4ZM13.5488 4L9.99998 6.2445L13.5488 8.48899L17.0977 6.2445L13.5488 4ZM2.90228 10.7333L6.45085 12.9776L9.99998 10.7333L6.45085 8.48899L2.90228 10.7333ZM13.5488 8.48899L9.99998 10.7335L13.5488 12.9779L17.0977 10.7335L13.5488 8.48899ZM6.45113 13.7305L10.0003 15.9748L13.5488 13.7305L10.0003 11.4862L6.45113 13.7305Z",
    fill: "#0061FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6026_29005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2642,
    height: 12,
    fill: "white",
    transform: "translate(2.86792 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDropbox);
export default __webpack_public_path__ + "static/media/ic-dropbox.71f0690abfa77cc6ad276af6d0ccebcb.svg";
export { ForwardRef as ReactComponent };